import api from './api';

// Obter todos os conflitos do usuário
export const getConflicts = async () => {
  try {
    console.log('Chamando API para buscar conflitos:', `${api.defaults.baseURL}/conflicts`);
    const response = await api.get('/conflicts');
    console.log('Resposta da API (conflitos):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar conflitos:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Obter um conflito específico
export const getConflict = async (id) => {
  try {
    const response = await api.get(`/conflicts/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao buscar conflito ${id}:`, error);
    throw error;
  }
};

// Criar um novo conflito
export const createConflict = async (conflictData) => {
  try {
    console.log('Chamando API para criar conflito:', `${api.defaults.baseURL}/conflicts`);
    console.log('Dados do conflito:', conflictData);
    const response = await api.post('/conflicts', conflictData);
    console.log('Resposta da API (criar conflito):', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar conflito:', error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Atualizar um conflito
export const updateConflict = async (id, conflictData) => {
  try {
    const response = await api.put(`/conflicts/${id}`, conflictData);
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar conflito ${id}:`, error);
    throw error;
  }
};

// Atualizar uma etapa de resolução
export const updateResolutionStep = async (id, stepNumber, userInput) => {
  try {
    const response = await api.put(`/conflicts/${id}/steps/${stepNumber}`, { userInput });
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar etapa ${stepNumber} do conflito ${id}:`, error);
    throw error;
  }
};

// Marcar um conflito como resolvido
export const resolveConflict = async (id) => {
  try {
    const response = await api.put(`/conflicts/${id}/resolve`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao resolver conflito ${id}:`, error);
    throw error;
  }
};

// Reabrir um conflito resolvido
export const reopenConflict = async (id, comment) => {
  try {
    console.log(`Chamando API para reabrir conflito ${id}:`, `${api.defaults.baseURL}/conflicts/${id}/reopen`);
    console.log('Comentário sobre a reincidência:', comment);
    const response = await api.put(`/conflicts/${id}/reopen`, { comment });
    console.log('Resposta da API (reabrir conflito):', response.data);
    return response.data;
  } catch (error) {
    console.error(`Erro ao reabrir conflito ${id}:`, error);
    console.error('Detalhes do erro:', error.response ? {
      status: error.response.status,
      data: error.response.data,
      headers: error.response.headers
    } : 'Sem resposta do servidor');
    throw error;
  }
};

// Excluir um conflito
export const deleteConflict = async (id) => {
  try {
    const response = await api.delete(`/conflicts/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao excluir conflito ${id}:`, error);
    throw error;
  }
};
